/* eslint-disable react/jsx-pascal-case */

/* Original name @uswitch/trustyle.call-out */
import * as React from 'react';
import { Themed } from 'theme-ui';
import { Palette } from '@uswitch/ev-core/react';
import { DynamicSparkIcon } from '../spark-icons/dynamic-spark-icon';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var CallOut = function CallOut(_ref) {
  var title = _ref.title,
      text = _ref.text,
      icon = _ref.icon,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'left' : _ref$orientation,
      _ref$bold = _ref.bold,
      bold = _ref$bold === void 0 ? false : _ref$bold,
      className = _ref.className;
  var flexDirection = orientation === 'left' ? 'row' : 'column';

  var mainText = _jsxs(React.Fragment, {
    children: [title ? _jsx(Themed.h3, {
      sx: {
        marginTop: '-3px',
        marginBottom: 'xxs',
        variant: 'elements.call-out.heading'
      },
      children: title
    }) : null, _jsx(Palette, {
      as: Themed.p,
      sx: {
        marginY: 0,
        variant: 'elements.call-out.text',
        fontWeight: bold ? '700' : 'normal'
      },
      px: {
        color: 'accentColorText'
      },
      children: text
    })]
  });

  return _jsxs(Palette, {
    as: "div",
    sx: {
      borderRadius: 4,
      paddingX: 'sm',
      paddingY: 'sm',
      variant: 'elements.call-out.main'
    },
    px: {
      backgroundColor: 'accentColor'
    },
    className: className,
    children: [icon ? _jsxs("div", {
      sx: {
        display: 'flex',
        flexDirection: flexDirection
      },
      children: [_jsx("div", {
        sx: {
          flexGrow: 0,
          flexShrink: 0,
          flexBasis: function flexBasis(_ref2) {
            var space = _ref2.space;
            return space.sm;
          },
          marginRight: 'xs',
          marginBottom: 'sm',
          variant: 'elements.call-out.icon-container'
        },
        children: _jsx("div", {
          sx: {
            borderRadius: '50%',
            padding: '20%',
            variant: 'elements.call-out.icon'
          },
          children: _jsx(DynamicSparkIcon, {
            color: "white",
            glyph: icon
          })
        })
      }), _jsx("div", {
        children: mainText
      })]
    }) : null, !icon ? mainText : null]
  });
};

export default CallOut;
//# sourceMappingURL=index.js.map